const BASE_API_URL = process.env.REACT_APP_API_URL;
const API_URL = BASE_API_URL + "/v1";

export const SCORES_URL = API_URL + "/scores";
